<div fxLayout="row" [class]="getClass" class="mat-simple-snackbar">
	<div class="snackbar-content">
		<mat-icon class="snackbar-icon">{{ getIcon }}</mat-icon>
		<span class="snackbar-message" data-cy="snackbar-message">{{ data.message }}</span>
	</div>
	<button mat-button class="mat-button" (click)="close()">
		<mat-icon>close_small</mat-icon>
	</button>
</div>
